const ROUTES = {
    ROOT: "/",
    ABOUT_SITE: "/about-this-site",
    ABOUT_ME: "/about-me",
    HISTORICAL_TIMELINE: "/my-timeline",
    FRAMEWORKS: "/framework",
    PROJECTS: "/projects",
    CREDENTIALS: "/credentials",
    SKILLS: "/skills",
    HISTORY: "/my-history"
}

export default ROUTES;